import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { convertApiItemResponseToItem } from '../../core/utils';
import { CrmApiService } from '../../core/services/crm-api.service';
import { BackendApiResponse, EntityId, PriceItem } from '../../core/types';

@Injectable({
  providedIn: 'root',
})
export class PriceApiService extends CrmApiService {
  getPriceSet(id: EntityId): Observable<PriceItem[]> {
    return this.api.get<BackendApiResponse<PriceItem[]>>(`${this.baseEndpoint}price-sets/${id}/prices/`).pipe(
      convertApiItemResponseToItem,
      catchError(() => of([])),
    );
  }
}
